export const COLLECTION_FLOW_PROCESS_NAME = 'collection-flow' as const;
